import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { ForgeIcon } from '@tylertech/forge-react';

import { I18n } from 'common/i18n';
import { ForgeStatusIcons, StatusValues, STATUS_ENDED } from 'common/performance_measures/lib/constants';

const StatusIcon = ({ value }) => {
  /*
  checks that we are not trying to render an icon for 'ended' status.
  the StatusBanner component is potentially passing 'ended' status to
  StatusIcon but StatusIcon doesn't handle this case because no such value
  is defined in ForgeStatusIcons. must add STATUS_ENDED to StatusIcon propTypes
  because otherwise it fails propType validation.
  */

  const icon = ForgeStatusIcons[value];
  return icon ? <ForgeIcon name={icon} /> : null;
};

StatusIcon.propTypes = {
  value: PropTypes.oneOf([...Object.values(StatusValues), STATUS_ENDED]).isRequired,
};

/**
 * Creates a status banner for the Measure Result Card.
 *
 * Status is user configured as part of measure creation.
 * Props:
 * - value -- specifies the color, icon, and default label. If not provided, the status banner is disabled.
 * - labels -- overrides specific to each possible value
 */
const StatusBanner = ({ ended, value, labels }) => {
  if (!value) {
    return null;
  }

  const labelOverride = labels && labels[value];
  const labelDefault = I18n.t(`shared.performance_measures.measure.status.values.${value}`);
  const label = ended ? labels.ended : labelOverride || labelDefault;

  return (
    <div className={`status-banner status-banner-${value}`}>
      <div className="status-banner-content">
        <StatusIcon value={value} />
        <span className="status-banner-text" title={label}>
          {label}
        </span>
      </div>
      <div className="flag-ends"></div>
    </div>
  );
};

StatusBanner.propTypes = {
  ended: PropTypes.bool,
  labels: PropTypes.objectOf(PropTypes.string),
  value: PropTypes.oneOf([..._.values(StatusValues), STATUS_ENDED]),
};

export default StatusBanner;
